import { Component } from '@angular/core';

@Component({
  selector: 'wzc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {}
